// This is for one-off requests to the API that happen outside of the RTK Query
// You probably don't want to be using this in most cases.

export function appFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(options.headers);
  headers.set('X-UGC-Account', window.location.pathname.split('/')[1]);

  return fetch(import.meta.env.REACT_APP_API_SERVER_URL + url, {
    credentials: 'include',
    ...options,
    headers,
  });
}
